import { Injectable } from '@angular/core';
import { ServiceBase, OrigamiResponse } from './base/service.base';
import { Observable } from 'rxjs';

export interface TemplatePattern {
  Description: string;
  Id: number;
  PatternName: string;
  TemplateType: number;
  TemplateTypeId: number;
}

export interface TemplateType {
  Disabled: boolean;
  Id: number;
  IsDomainLevel: boolean;
  TemplateCategoryId: number;
  TemplateName: string;
  TemplatePatterns: TemplatePattern[];
}

export interface Template {
  Body: string;
  DomainId: number;
  Id: number;
  SiteId: number;
  Subject: string;
  TemplateType: TemplateType;
  TemplateTypeId: number;
}

@Injectable()
export class TemplateService extends ServiceBase {
  serviceUrl = 'TemplateService.svc';

  getTemplateTypes(
    body: { siteId: number; isDomainLevel: boolean; templateCategories: any[] },
    ...params
  ): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/GetTemplateTypes', body, ...params);
  }

  createTemplate(options: {
    siteId: number;
    templateType: number;
    body: string;
    subject: string;
  }): Observable<OrigamiResponse<any>> {
    return this.origamiPost('/CreateTemplate', options, null, null, true);
  }

  editTemplate(template: any): Observable<OrigamiResponse<Template>> {
    return this.origamiPost('/EditTemplate', { template }, null, null, true);
  }

  getTemplate(body: { siteId: number; templateType: number }, ...params): Observable<OrigamiResponse<Template>> {
    return this.origamiPost('/GetTemplate', body, ...params);
  }
}
